import { getCoreRowModel, getPaginationRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { Plus } from 'lucide-react';
import { Button } from '../../../../../design-system/button/button';
import { DataTableNew } from '../../../../../design-system/data-table-new';
import { Inline } from '../../../../../design-system/inline/inline';
import { Stack } from '../../../../../design-system/stack/stack';
import { EmployeeView } from '../../../../../types/entity-types';
import { employeeTableColumnDefinition, firstNameId } from './employee-table-column-definitions';

const PAGE_SIZE = 20;

type EmployeeTableProps = {
  employees: EmployeeView[];
  onEditEmployee: (employeeId: string) => void;
  onAddEmployee: () => void;
};

export const EmployeeTable = ({ employees, onEditEmployee, onAddEmployee }: EmployeeTableProps) => {
  const table = useReactTable({
    data: employees,
    columns: employeeTableColumnDefinition,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    initialState: {
      sorting: [{ id: firstNameId, desc: false }],
      pagination: {
        pageSize: PAGE_SIZE,
      },
    },
  });

  return (
    <Stack space={4} align="stretch">
      <Inline justify="end">
        <Button variant="default" iconLeft={<Plus />} onClick={onAddEmployee}>
          Add Employee
        </Button>
      </Inline>
      <DataTableNew.Table
        table={table}
        onSelectRow={(id) => onEditEmployee(id)}
        noResultsMessage="No results"
        aria-label="Employees table"
      />
      {table.getPageCount() > 1 && (
        <Inline justify="end">
          <DataTableNew.Pagination table={table} />
        </Inline>
      )}
    </Stack>
  );
};
